import styled from "@emotion/styled";

export const LensStatusPanelContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
